import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.section`
  display : flex;
  flex-direction : column;
  width: 100%;
`

const FullWidthLayout  = ({children, style}) => {
    return (
        <Wrapper style={style}>
            {children}
        </Wrapper>
    )
}

export default FullWidthLayout;